import $ from 'jquery';
import Bootstrap from '../vendors/bootstrap.js';


class MarsScripts {
  constructor() {
    this.events();
    this.siteBody = $('body');
    $('body').removeClass('js-loading');
  }

  events() {
    window.addEventListener('load', (event) => {
      this.displayLogoIfDelay.bind(this);
      this.newsletterEmailPush(this);
    });

    this.newsletterEmailPush(this);
    this.disableImgHover(this);

    this.anchorScroll();
    this.copyLink();

    if ($('.videoBlock__video-overlay').length) {
      $('.videoBlock__video-overlay, .videoBlock__video-overlay *').on(
        'click',
        this.playVideo.bind(this)
      );
    }

    if ($('.videoGallery__video-overlay').length) {
      $('.videoGallery__video-overlay, .videoGallery__video-overlay *').on(
        'click',
        this.playVideo.bind(this)
      );
    }

    if ($('.homepageHeader__downArrow, .hubsSlider__downArrow').length) {
      $('.homepageHeader__downArrow, .hubsSlider__downArrow').on('click', function () {
        $('html, body').animate(
          {
            scrollTop: $('.page-content').offset().top - 50,
          },
          'slow'
        );
      });
    }

    if (
      $('.singlePageHeader__openForm').length &&
      $('.singlePageHeader__form').length
    ) {
      $('.singlePageHeader__openForm').on('click', function () {
        $('.singlePageHeader__buttons').hide('slow');
        $('.singlePageHeader__form').show('slow');
      });
    }
  }

  displayLogoIfDelay() {
    if ($('body').hasClass('home')) {
      this.siteBody.delay(3000).fadeOut(500, function () {
        this.siteBody.removeClass('js-loading');
      });
    } else {
      this.siteBody.delay(1200).fadeOut(500, function () {
        this.siteBody.removeClass('js-loading');
      });
    }
  }

  newsletterEmailPush() {
    let getUrlParameter = function getUrlParameter(sParam) {
      let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    };

    if (getUrlParameter('memail')) {
      setTimeout(function () {
        $('#mce-EMAIL').val(getUrlParameter('memail'));
        $('#mce-EMAIL')
          .parent('.fsRowBody, .mc-field-group')
          .addClass('filled');
      }, 1000);
    }
  }

  disableImgHover() {
    //Target and add class to A tags containing logos/images added inside a wysiwyg
    $('div > p > a > img').parent().addClass('no-hover');
  }

  playVideo(e) {
    e.preventDefault();

    console.log('playVideo');
    let videoBlock = $(e.target).parent().find('video');

    if (!videoBlock.length) {
      videoBlock = $(e.target).parent().parent().find('video');
    }

    $(videoBlock).trigger('play');
    $(videoBlock).attr('controls', true);
    $(e.target).remove();
  }

  anchorScroll() {
    $('.anchors__link').click(function () {
      let targetID = $(this).attr('target-data');
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $('#' + targetID).offset().top - 150,
        },
        500,
        'linear'
      );
    });
  }

  copyLink(){
    const toastLiveExample = document.getElementById('liveToast')
    $('.copy-link').on('click', function () {
      navigator?.clipboard?.writeText(window?.location?.href);
      console.log("Copied to clipboard!");
      const toastBootstrap = Bootstrap.Toast.getOrCreateInstance(toastLiveExample)
      console.log('toastBootstrap');
      toastBootstrap?.show();
      console.log('show toastBootstrap');

    });
  }
}

export default MarsScripts;
